import { useState } from "react";
import { Select, InputStyledDiv, Close, Info } from "components";
import { FilterItem, TableFilter, TableHeading, TableOptions } from "components/Table";
import { useCompanyManagementContext } from "pages/CompanyManagement/utils/CompanyManagementContext";
import { STATUSES } from "helpers";
import { twMerge } from "tailwind-merge";
import { t } from "i18next";

export const CompanyTableHeadings = () => {
  const { params, onResetFilters, onSort, onFilterByStatus } = useCompanyManagementContext();

  const [showInfo, setShowInfo] = useState<boolean>(false);

  const resetFilters = (
    <div className="absolute -mt-1.5 flex flex-col">
      {showInfo && (
        <InputStyledDiv className="absolute -mt-4 ml-6 w-max bg-primary/5 p-0 text-xs font-thin">
          Clear All Filters
        </InputStyledDiv>
      )}
      <div onMouseEnter={() => setShowInfo(true)} onMouseLeave={() => setShowInfo(false)} className="relative">
        <Info width={7} height={7} className="ml-4" />
      </div>
      <Close className="text-error-text" onClick={onResetFilters} />
    </div>
  );

  const headings: Array<JSX.Element | string> = [
    <>
      {resetFilters}
      <TableHeading onClick={() => console.log("")}>{t("companyManagement.uniqueNumberID")}</TableHeading>
    </>,
    <TableHeading onClick={(order) => onSort("name", order)} order={params.order || "DESC"}>
      {t("companyManagement.name")}
    </TableHeading>,
    <TableHeading onClick={(order) => onSort("email", order)}>{t("companyManagement.email")}</TableHeading>,
    <TableHeading onClick={(order) => onSort("phone_number", order)}>
      {t("companyManagement.phoneNumber")}
    </TableHeading>,
    <TableHeading onClick={(order) => onSort("address", order)}>{t("companyManagement.address")}</TableHeading>,
    <TableFilter
      onFilter={onFilterByStatus}
      values={STATUSES}
      label={t("companyManagement.status")}
      selectedFilter={params.status as FilterItem | undefined}
    />,
    <TableOptions>{t("companyManagement.options")}</TableOptions>,
  ];

  return (
    <>
      {headings.map((heading, index) => {
        const isLast = index === headings.length - 1;

        return (
          <th
            key={index}
            scope="col"
            className={twMerge(
              "h-[100px] max-h-[100px] w-[200px] min-w-[200px] break-words bg-white py-4 text-sm font-semibold text-primary",
              isLast && "shadow-left sticky right-0 z-10"
            )}
          >
            {heading}
          </th>
        );
      })}
    </>
  );
};
